<template>
  <div class="prompt-wrap prompt-wrap-v2">
    <div v-if="insTypeList" class="risk-box">
      <dl class="risk">
        <dd class="bd">
          <p
            v-for="(item, index) in insTypeList"
            :key="index"
          >
            {{ item }}
          </p>
        </dd>
      </dl>
    </div>
    <div class="reminder" />
  </div>
</template>

<script>
  import { insTypeOrders } from 'base/config'
  import riskContent from './riskContent'

  export default {
    props: {
      typeList: {
        type: [Array, Object],
        default() {
          return []
        }
      },
      categorySort: {
        type: String,
        default: 'normal'
      },
      sortList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      insTypeList() {
        const { sortList, typeList, categorySort } = this
        const insTypeOrder = Array.isArray(sortList) && sortList.length > 0 ? sortList : insTypeOrders[categorySort || 'normal']
        return riskContent(typeList, insTypeOrder)
      }
    }
  }
</script>

<style lang="postcss">
  @import 'variable-v2';
  .prompt-wrap {
    position: relative;
    @apply --widthcenter;
    color: var(--nine-color);
    font-size: 0.26rem;
  }
  .risk-box {
    @apply --box;
    padding: 0.24rem;
    color: var(--thre-color);
    .risk {
      background: #f8f8f8;
      padding: 0.3rem 0.3rem 0.1rem;
      border-radius: 6px;;
    }
    .hd {
      font-size: 0.34rem;
      font-weight: bold;
      margin-bottom: 0.16rem;
      text-align: center;
    }
    .bd {
      font-size: 0.3rem;
      padding-left: 0.3rem;
    }
    p {
      position: relative;
      line-height: 1.5;
      margin-bottom: 9px;
      text-align: left;
      &:before {
        content: '';
        position: absolute;
        left: -15px;
        top: 7px;
        font-size: 20px;
        line-height: 1;
        vertical-align: middle;
        width: 6px;
        height: 6px;
        border-radius: 50%;
      }
    }
  }
</style>